module.exports = __webpack_public_path__ + "img/pb1.4b5994b3.jpg";